import { CommunicationProviderType } from './communication-provider';

export interface NotificationProviderBinding {
  providerName: string;
  isActive: boolean;
  configuration: string;
  createdAt: Date;
}

export interface Recipient {
  id: string;
  preferredLocale: string;
  endpoints: RecipientEndpoint[];
}

export interface RecipientEndpoint {
  id: string;
  providerType: CommunicationProviderType;
  providerProfileId: string;
  config: RecipientEndpointConfig;
  doiConfirmed: boolean;
  doiConfirmedAt: Date;
  deletable: boolean;
  image?: string;
}

export type RecipientEndpointConfig =
  | ProviderChannelMetadata
  | ProviderAddressMetadata;

export interface ProviderChannelMetadata {
  id: string;
  name: string;
}

export function hasProviderChannelMetadata(
  endpoint: RecipientEndpoint
): boolean {
  switch (endpoint.providerType) {
    case CommunicationProviderType.DISCORD_APP:
      return true;
    case CommunicationProviderType.SLACK_APP:
      return true;
    case CommunicationProviderType.TEAMS:
      return true;
  }
  return false;
}

export interface ProviderAddressMetadata {
  address: string;
}

export function hasProviderAddressMetadata(
  endpoint: RecipientEndpoint
): boolean {
  switch (endpoint.providerType) {
    case CommunicationProviderType.MAIL:
      return true;
    case CommunicationProviderType.FCM:
      return true;
  }
  return false;
}

export interface RecipientEndpointSpec {
  slackApp?: ChannelEndpointSpec;
  discordApp?: ChannelEndpointSpec;
  teams?: ChannelEndpointSpec;
  fcm?: FCMEndpointSpec;
}

export interface ChannelEndpointSpec {
  channelId?: string;
  channelName?: string;
}

export interface FCMEndpointSpec {
  token: string;
  identifier: string;
}
